import instance from "@/services/api";

export const tierBlocksAPI = {
  async getBlocksList(params) {
    return await instance()
      .get("/common/blocks/read/", { params })
      .then((res) => res?.data);
  },
  async modifyBlock(body, params) {
    return await instance()
      .post("/common/blocks/modify/", body, { params })
      .then((res) => res?.data);
  },
  async deleteBlock(block_id) {
    return await instance()
      .delete(`/common/blocks/delete/${block_id}/`)
      .then((res) => res?.data);
  },
  async getEmployees() {
    return await instance()
      .get(`/common/blocks/employees/read/`)
      .then((res) => res?.data);
  },
  async getWorkGroupDict() {
    return await instance()
      .get(`/common/blocks/work_group_dict/read/`)
      .then((res) => res?.data);
  },
  async getResidents() {
    return await instance()
      .get(`/common/blocks/residents/read/`)
      .then((res) => res?.data);
  },
  async getWorkGroupsList(block_id) {
    return await instance()
      .get(`/common/blocks/${block_id}/work_groups/read/`)
      .then((res) => res?.data);
  },
  async modifyWorkGroup(body) {
    return await instance()
      .post("/common/blocks/work_groups/modify/", body)
      .then((res) => res?.data);
  },
  async deleteWorkGroup(work_group_id) {
    return await instance()
      .delete(`/common/blocks/work_groups/delete/${work_group_id}/`)
      .then((res) => res?.data);
  },
  async getWorkGroupDeleteStats(work_group_id) {
    return await instance()
      .get(`/common/blocks/work_groups/delete_stats/${work_group_id}/`)
      .then((res) => res?.data);
  },
  async getTasksByWorkGroupDict(work_group_dict_id) {
    return await instance()
      .get("/common/blocks/work_groups/tasks/read/", { params: { work_group_dict_id } })
      .then((res) => res?.data);
  },
  async getWorkGroupLevels(work_group_id) {
    return await instance()
      .get("/common/blocks/work_groups/levels/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async modifyWorkGroupLevel(body) {
    return await instance()
      .post("/common/blocks/work_groups/levels/modify/", body)
      .then((res) => res?.data);
  },
  async deleteWorkGroupLevel(work_group_level_id) {
    return await instance()
      .delete(`/common/blocks/work_groups/levels/delete/${work_group_level_id}/`)
      .then((res) => res?.data);
  },
  async bulkAddWorkGroupLevels(body) {
    return await instance()
      .post("/common/blocks/work_groups/levels/bulk_add/", body)
      .then((res) => res?.data);
  },
  async deleteWorkGroupTask(work_group_id, task_dict_id) {
    return await instance()
      .post("/tier/work_group_task/delete/", { work_group_id, task_dict_id })
      .then((res) => res?.data);
  },
  async addMissingWorkGroupTasks(work_group_id, work_group_dict_id) {
    return await instance()
      .post("/tier/work_group_task/add_missing/", { work_group_id, work_group_dict_id })
      .then((res) => res?.data);
  },
  // Block Employees
  async getBlockEmployees(block_id) {
    return await instance()
      .get("/common/blocks/employees/block/read/", { params: { block_id } })
      .then((res) => res?.data);
  },
  async addBlockEmployee(body) {
    return await instance()
      .post("/common/blocks/employees/block/add/", body)
      .then((res) => res?.data);
  },
  async deleteBlockEmployee(block_employee_id) {
    return await instance()
      .delete(`/common/blocks/employees/block/delete/${block_employee_id}/`)
      .then((res) => res?.data);
  },
  async copyBlockEmployees(body) {
    return await instance()
      .post("/common/blocks/employees/block/copy/", body)
      .then((res) => res?.data);
  },
  async fullRecalcAll() {
    return await instance()
      .post("/tier/full_recalc_all/")
      .then((res) => res?.data);
  },
  async getPlanFactAnomalies() {
    return await instance()
      .get("/tier/plan_fact/anomalies/read/")
      .then((res) => res?.data);
  },
  async getWorkGroupLevelDetail(work_group_id) {
    return await instance()
      .get("/tier/work_group_level_detail/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
};
